export type DrawingSubject = {
    id: string;
    urlId: string;
    displayName: {
        short: string;
        long: string;
    };
    icon: string;
};

// Download model JSONs from
// https://storage.googleapis.com/quickdraw-models/sketchRNN/large_models/[id].gen.json

const DrawingSubjects: Record<string, DrawingSubject> = {
    flower: {
        id: 'flower',
        urlId: 'bloem',
        displayName: {
            short: 'bloem',
            long: 'een bloem',
        },
        icon: '🌼',
    },
    cat: {
        id: 'cat',
        urlId: 'kat',
        displayName: {
            short: 'kat',
            long: 'een kat',
        },
        icon: '🐱',
    },
    pig: {
        id: 'pig',
        urlId: 'varken',
        displayName: {
            short: 'varken',
            long: 'een varken',
        },
        icon: '🐷',
    },
    ant: {
        id: 'ant',
        urlId: 'mier',
        displayName: {
            short: 'mier',
            long: 'een mier',
        },
        icon: '🐜',
    },
    // cactus: {
    //     id: 'cactus',
    //     urlId: 'cactus',
    //     displayName: {
    //         short: 'cactus',
    //         long: 'een cactus',
    //     },
    //     icon: '🌵',
    // },
    snail: {
        id: 'snail',
        urlId: 'slak',
        displayName: {
            short: 'slak',
            long: 'een slak',
        },
        icon: '🐌',
    },
    eye: {
        id: 'eye',
        urlId: 'oog',
        displayName: {
            short: 'oog',
            long: 'een oog',
        },
        icon: '👁️',
    },
    face: {
        id: 'face',
        urlId: 'gezicht',
        displayName: {
            short: 'gezicht',
            long: 'een gezicht',
        },
        icon: '😀',
    },
    // snowflake: {
    //     id: 'snowflake',
    //     urlId: 'sneeuwvlok',
    //     displayName: {
    //         short: 'sneeuw',
    //         long: 'een sneeuwvlok',
    //     },
    //     icon: '❄️',
    // },
    castle: {
        id: 'castle',
        urlId: 'kasteel',
        displayName: {
            short: 'kasteel',
            long: 'een kasteel',
        },
        icon: '🏰',
    },
    hand: {
        id: 'hand',
        urlId: 'hand',
        displayName: {
            short: 'hand',
            long: 'een hand',
        },
        icon: '✋',
    },
    frog: {
        id: 'frog',
        urlId: 'kikker',
        displayName: {
            short: 'kikker',
            long: 'een kikker',
        },
        icon: '🐸',
    },
    // strawberry: {
    //     id: 'strawberry',
    //     urlId: 'aardbei',
    //     displayName: {
    //         short: 'aardbei',
    //         long: 'een aardbei',
    //     },
    //     icon: '🍓',
    // },
    // backpack: {
    //     id: 'backpack',
    //     urlId: 'rugzak',
    //     displayName: {
    //         short: 'rugzak',
    //         long: 'een rugzak',
    //     },
    //     icon: '🎒',
    // },
    octopus: {
        id: 'octopus',
        urlId: 'octopus',
        displayName: {
            short: 'octopus',
            long: 'een octopus',
        },
        icon: '🐙',
    },
};

export const getDrawingSubjectFromUrlId = (
    urlId: string,
): DrawingSubject | undefined =>
    Object.values(DrawingSubjects).find((subject) => subject.urlId === urlId);

export default DrawingSubjects;
